import React, { Component } from 'react';
import PropTypes from 'prop-types';

var BezierSquare = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%221024px%22%20height%3D%221024px%22%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon%20Shape%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M357.009067%2C0%20L666.990933%2C0%20C769.792%2C0%20821.179733%2C0%20876.5184%2C17.4933333%20C936.9344%2C39.4837333%20984.516267%2C87.0656%201006.50667%2C147.4816%20C1024%2C202.811733%201024%2C254.216533%201024%2C357.009067%20L1024%2C666.990933%20C1024%2C769.792%201024%2C821.179733%201006.50667%2C876.5184%20C984.516267%2C936.9344%20936.9344%2C984.516267%20876.5184%2C1006.49813%20C821.179733%2C1024%20769.792%2C1024%20666.990933%2C1024%20L357.009067%2C1024%20C254.208%2C1024%20202.811733%2C1024%20147.4816%2C1006.49813%20C87.0656%2C984.516267%2039.4837333%2C936.9344%2017.4933333%2C876.5184%20C0%2C821.179733%200%2C769.792%200%2C666.990933%20L0%2C357.009067%20C0%2C254.216533%200%2C202.811733%2017.4933333%2C147.4816%20C39.4837333%2C87.0656%2087.0656%2C39.4837333%20147.4816%2C17.4933333%20C202.811733%2C0%20254.208%2C0%20357.009067%2C0%20L357.009067%2C0%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Icon-Shape%22%20fill%3D%22%23000000%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var ReactBezierMask = function (_Component) {
  inherits(ReactBezierMask, _Component);

  function ReactBezierMask() {
    classCallCheck(this, ReactBezierMask);
    return possibleConstructorReturn(this, (ReactBezierMask.__proto__ || Object.getPrototypeOf(ReactBezierMask)).apply(this, arguments));
  }

  createClass(ReactBezierMask, [{
    key: 'render',
    value: function render() {

      var style = Object.assign({}, {
        display: 'inline-flex',
        overflow: 'hidden',
        WebkitMask: 'url(' + BezierSquare + ') 0% 0% / contain no-repeat',
        mask: 'url(' + BezierSquare + ') 0% 0% / contain no-repeat'
      }, this.props.style);

      return React.createElement(
        'div',
        { style: style },
        this.props.children
      );
    }
  }]);
  return ReactBezierMask;
}(Component);

ReactBezierMask.props = {
  style: PropTypes.object,
  children: PropTypes.node.isRequired
};

export default ReactBezierMask;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0